import React, { useEffect, useState } from "react";

export default function EnlaceView() {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    localStorage.setItem("from_nitro", "true");

    const run = async () => {
      try {
        const res = await fetch("http://isight.cl/mel/enlace/mint.php", {
          method: "GET",
          credentials: "include",
          cache: "no-store",
        });

        const data = await res.json();

        if (!res.ok || !data.ok) {
          window.location.href = "http://isight.cl";
          return;
        }

        const url =
          `http://isight.cl/mel/enlace/index.php?view=enlace` +
          `&u=${encodeURIComponent(data.u)}` +
          `&ts=${encodeURIComponent(data.ts)}` +
          `&sig=${encodeURIComponent(data.sig)}`;

        setSrc(url);
      } catch (e) {
        window.location.href = "http://isight.cl";
      }
    };

    run();
  }, []);

  if (!src) return <div style={{ padding: 20, color: "#aaa" }}>Cargando enlace...</div>;

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        title="Enlace"
        src={src}
        style={{ width: "100%", height: "100%", border: 0 }}
      />
    </div>
  );
}
